import Em from 'ember';
export default Em.Component.extend({
  classNames: ['embercom-composer-debug'],
  composerState: null,
  stringifiedBlocks: Em.computed('composerState.jsonBlocks', function () {
    return this.get('composerState') ? JSON.stringify(JSON.parse(this.get('composerState.jsonBlocks')), undefined, 2) : '';
  }),
  stringifiedBoundBlocks: Em.computed('blocks', function () {
    return this.get('blocks') ? JSON.stringify(this.get('blocks'), undefined, 2) : '';
  }),
  actions: {
    toggleConfig(name) {
      this.toggleProperty(`config.${name}`);
      this.load?.(this.get('blocks'));
    }
  }
});